// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"39":"fd782571","161":"4b23b001","848":"ccd9938e"}[chunkId] + ".chunk.js";
};